import { valueToEnumOrNull } from 'common/EnumUtils';
import { BrowseByTagsType, ClientEvents } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import React, { useCallback } from 'react';
import { DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { QueryParamsUpdates, QueryParamsUpdateType } from 'src/pages/consumer/explore/useExploreUrl';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Segment } from './Segment';
import { Category } from './types';

interface CategoryProps {
  categories: Category[];
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
}

export const CategoryCollection: React.FC<CategoryProps> = ({ categories, updateQueryParams }) => {
  const tracker = useTracker();

  const onClick = useCallback(
    (value: string, position: number) => {
      const segmentFilter = valueToEnumOrNull(DishFirstSegmentFilter, value);
      if (!segmentFilter) return;

      const filters = {
        [QueryParams.SEGMENT_FILTER]: [segmentFilter],
      };
      updateQueryParams(filters, 'pushIn');
      tracker.track(ClientEvents.BROWSE_BY_TAGS_CLICK, { tag: value, type: BrowseByTagsType.COLLECTION, position });
    },
    [updateQueryParams, tracker]
  );
  return <Segment title='Browse shefs by category' categories={categories} onClick={onClick} />;
};
